import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { SIGNAL_METHODS, SIGNAL_METHOD_LABELS } from '@/services/api/classificationService';

interface Props {
  value: string;
  onChange: (method: string) => void;
  disabled?: boolean;
}

export function SignalMethodSelector({ value, onChange, disabled }: Props) {
  const handleChange = (e: SelectChangeEvent) => onChange(e.target.value);

  return (
    <FormControl size="small" fullWidth disabled={disabled}>
      <InputLabel id="signal-method-label">Signal Extraction Method</InputLabel>
      <Select
        labelId="signal-method-label"
        value={value}
        label="Signal Extraction Method"
        onChange={handleChange}
      >
        {SIGNAL_METHODS.map((m) => (
          <MenuItem key={m} value={m}>
            {SIGNAL_METHOD_LABELS[m]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
